"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var networker_1 = require("@idp/networker");
var StateProvider_1 = require("./StateProvider");
var UtilityFunctions_1 = require("../utils/UtilityFunctions");
var CartNetworker = /** @class */ (function () {
    function CartNetworker(interceptor) {
        this.networker = new networker_1.Networker(interceptor);
        this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
    }
    /**
     * Delete Rest API.
     * @param {string} url
     * @param {NetworkerMethodOptions} options.
     * @param {boolean} withCache. Optional. If true then do not use cache. Default is false => do not use cache.
     * @param {number} timeOutValue. Optional. If true then will timeout response after given time. Default is 0.
     * @returns {Promise<T>}
     */
    // tslint:disable-next-line:no-any
    CartNetworker.prototype.delete = function (url, options, withCache, timeOutValue) {
        var _this = this;
        if (options === void 0) { options = {}; }
        return this.networker
            .delete(url, options, withCache, timeOutValue)
            .then(UtilityFunctions_1.rejectHTTPErrors)
            .then(function (response) { return response.json(); })
            .catch(function (err) {
            _this.handleBESessionTimoutFailure(err);
            return Promise.reject(err);
        });
    };
    /**
     * Get Rest API.
     * @param {string} url
     * @param {NetworkerMethodOptions} options.
     * @param {boolean} withCache. Optional. If true then use cache. Default is false => No cache.
     * @param {number} timeOutValue. Optional. If true then will timeout response after given time. Default is 0.
     * @returns {Promise<T>}
     */
    // tslint:disable-next-line:no-any
    CartNetworker.prototype.get = function (url, options, withCache, timeOutValue) {
        var _this = this;
        if (options === void 0) { options = {}; }
        return this.networker
            .get(url, options, withCache, timeOutValue)
            .then(UtilityFunctions_1.rejectHTTPErrors)
            .then(function (response) { return response.json(); })
            .then(function (res) {
            return res;
        })
            .catch(function (err) {
            _this.handleBESessionTimoutFailure(err);
            return Promise.reject(err);
        });
    };
    /**
     * Post Rest API.
     * If 'content-type' is not provided in the header and body is not of type FormData,
     * set content-type is set to application/json'
     * If body is not string nor FormData, the function assume a JSON object is provided and stringify it.
     * @param {string} url
     * @param data. Can be any type. If FormData
     * @param {NetworkerMethodOptions} options.
     * @param {boolean} withCache. Optional. If true then use cache. Default is false => do not use cache.
     * @param {number} timeOutValue. Optional. If true then will timeout response after given time. Default is 0.
     * @returns {Promise<T>}
     */
    // tslint:disable-next-line:no-any
    CartNetworker.prototype.post = function (url, data, options, withCache, timeOutValue) {
        var _this = this;
        if (options === void 0) { options = {}; }
        return this.networker
            .post(url, data, options, withCache, timeOutValue)
            .then(UtilityFunctions_1.rejectHTTPErrors)
            .then(function (response) { return response.json(); })
            .then(function (res) {
            return res;
        })
            .catch(function (err) {
            _this.handleBESessionTimoutFailure(err);
            return Promise.reject(err);
        });
    };
    /**
     * Put Rest API.
     * If 'content-type' is not provided in the header and body is not of type FormData,
     * set content-type is set to application/json'
     * If body is not string nor FormData, the function assume a JSON object is provided and stringify it.
     * @param {string} url
     * @param data
     * @param {NetworkerMethodOptions} options
     * @param {boolean} withCache. Optional. If true then do use cache. Default is false => do not use cache.
     * @param {number} timeOutValue. Optional. If true then will timeout response after given time. Default is 0.
     * @returns {Promise<T>}
     */
    // tslint:disable-next-line:no-any
    CartNetworker.prototype.put = function (url, data, options, withCache, timeOutValue) {
        var _this = this;
        if (options === void 0) { options = {}; }
        return this.networker
            .put(url, data, options, withCache, timeOutValue)
            .then(UtilityFunctions_1.rejectHTTPErrors)
            .then(function (response) { return response.json(); })
            .catch(function (err) {
            _this.handleBESessionTimoutFailure(err);
            return Promise.reject(err);
        });
    };
    // tslint:disable-next-line:no-any
    CartNetworker.prototype.handleBESessionTimoutFailure = function (response) {
        if (response && response.error && (((Array.isArray(response.error)) &&
            // tslint:disable-next-line:no-any
            response.error.some(function (e) { return e && e.errorId && e.errorId.toLowerCase() === 'general-0004'; })) ||
            (response.error.errorId && response.error.errorId.toLowerCase() === 'general-0004'))) {
            this.stateManager.set('sessionExpired', { showModal: true });
        }
    };
    return CartNetworker;
}());
exports.default = CartNetworker;
//# sourceMappingURL=CartNetworker.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/CartNetworker.js
// module id = 1447
// module chunks = 8